let uniqueID = 0;
export const generateUniqueID = () => {
    uniqueID += 1;
    return `reactgooglegraph-${uniqueID}`;
};
